import { useEffect, useState } from 'react';

type Platform = 'android' | 'ios' | 'web';

interface PlatformInfo {
  isNative: boolean;
  isAndroid: boolean;
  isIOS: boolean;
  isWeb: boolean;
  platform: Platform;
}

/**
 * Hook to detect the current platform (web, Android, or iOS)
 * Useful for platform-specific UI and behavior
 */
export function usePlatform(): PlatformInfo {
  const [platform, setPlatform] = useState<Platform>('web');

  useEffect(() => {
    // Check if running in Capacitor
    const cap = (window as any).Capacitor;
    if (cap) {
      const platformName = cap.getPlatform?.();
      if (platformName === 'android') {
        setPlatform('android');
      } else if (platformName === 'ios') {
        setPlatform('ios');
      }
    }
  }, []);

  return {
    isNative: platform !== 'web',
    isAndroid: platform === 'android',
    isIOS: platform === 'ios',
    isWeb: platform === 'web',
    platform,
  };
}
